import { bootstrapApplication } from '@angular/platform-browser'
import { appConfig } from './app/app.config'
import { AppComponent } from './app/app.component'
import * as L from 'leaflet'

// Set Leaflet's default icon path
L.Icon.Default.imagePath = 'assets/images/'

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err))
